import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { emailTemplateService } from 'src/services';

export const emailTemplateStore = defineStore('email_template', {
  state: () => ({
    loading: false,
    display_data: [] as dynamicObj[],
    email_template_data: {
      value: '',
      email_type: '',
      doc_type: '',
      subject: '',
      name: null,
      email: '',
      id: 0,
    } as dynamicObj,
    sample_data: [] as dynamicObj[],
    stream_file_data: '',
    send_test_dialog: false,
    pagination: {
      current_page: 1,
      total_pages: 0,
      page_size: 10,
    },
  }),
  actions: {
    async getEmailTemplateData() {
      try {
        const response = await emailTemplateService.getList();
        if (!response) {
          throw response;
        }
        this.display_data = response?.data || [];
      } catch (err: any) {
        logError(err);
      }
    },
    async getGeneralEmailTemplateData() {
      try {
        const response = await emailTemplateService.getGeneralList();
        if (!response) {
          throw response;
        }
        this.display_data = response?.data || [];
      } catch (err: any) {
        logError(err);
      }
    },
    async getOneEmailTemplate(id: string) {
      try {
        const response = await emailTemplateService.getOne(id);
        if (response.success === false) {
          throw response;
        }
        if (response.data) {
          this.email_template_data = response.data;
        }
      } catch (err: any) {
        throw err;
      }
    },
    async createEmailTemplate(data: any) {
      try {
        const response = await emailTemplateService.create(data);
        if (response) {
          return response as dynamicObj;
        }
      } catch (err: any) {
        logError(err);
      }
    },
    async updateEmailTemplate(id: string, data: any) {
      try {
        const response = await emailTemplateService.update(id, data);
        if (response?.success) {
          return response?.success as dynamicObj;
        }
      } catch (err: any) {
        logError(err);
      }
    },
    async getSampleData() {
      try {
        const response = await emailTemplateService.emailTemplateData();
        if (!response) {
          throw response;
        }
        this.sample_data = response?.data;
      } catch (err: any) {
        logError(err);
      }
    },
    async sendTestEmail(data: any) {
      try {
        const response = await emailTemplateService.sendTest(data);
        if (response?.success) {
          return response?.success as dynamicObj;
        }
      } catch (err: any) {
        logError(err);
      }
    },
    async onUploadFile(file: any) {
      try {
        const response = await emailTemplateService.uploadFile(file);
        if (!response) {
          throw response;
        }
        this.stream_file_data = response?.data;
      } catch (err: any) {
        logError(err);
      }
    },
    resetEmailTemplateStore() {
      this.email_template_data = {
        value: '',
        email_type: '',
        doc_type: '',
        subject: '',
        name: null,
        email: '',
        id: 0,
      };
    },
  },
});
